import AOS from "aos";

function aosInit() {
    // aos config
    var aosElements = document.querySelectorAll(".aos-fade-up, .aos-item, .aos-delay");

    for (let i = 0; i < aosElements.length; i++) {
        aosElements[i].setAttribute("data-aos", "fade-up");
    }
    if (window.location.hash.length && !document.querySelector("#webinar-video-modal")) {
        $("body").addClass("disable-aos");
    }

    AOS.init({
        offset: 150,
        duration: 800,
        easing: "ease-out-quad",
        once: true
    });

    let refreshTimer;
    const refresh = function() {
        clearTimeout(refreshTimer);
        refreshTimer = setTimeout(function() {
            AOS.refresh();
        }, 100);
    };

    if (window.ResizeObserver) {
        new ResizeObserver(refresh).observe(document.body);
    } else {
        window.addEventListener("load", function() {
            setTimeout(refresh, 2500);
        });
    }

    // lazysizes fires this per image once the real source has loaded.
    document.addEventListener("lazyloaded", refresh);

    window.addEventListener("click", function(event) {
        if (window.device === "mobile" || (event.target.closest && event.target.closest(".ui-tabs-anchor, .collapse-toggle"))) {
            refresh();
        }
    });
}
export default aosInit;
